var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 18h22c.6 0 1-.4 1-1s-.4-1-1-1H1c-.6 0-1 .4-1 1s.4 1 1 1zM1 8h22c.6 0 1-.4 1-1s-.4-1-1-1H1c-.6 0-1 .4-1 1s.4 1 1 1z"}));
}

Hamburger.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
